import { Box, Typography, Fade, Divider } from '@mui/material';
import { t } from 'i18next';
import React, { useCallback, useState } from 'react';

import { PersonPlusIcon } from '@/assets/svg';
import { useReachedTeamSeatsLimit } from '@/hooks/useReachedTeamSeatsLimit';
import { COLOR, ENTITY_COLOR } from '@/theme/colors';

import Modal from '../Modal';
import { ReachedOutMaximumTeamCapacity } from '../ReachedOutMaximumTeamCapacity';

import { ContactInvitationForm, InvitationUrlSection } from './components';
import { Props } from './types';

function TeamInvitationModal({ handleClose, handleSuccessInvitation }: Props) {
    const [willReachSeatsLimit, setWillReachSeatsLimit] = useState(false);

    const { hasReachedSeatsLimit, takenSeats, seatsLimit } =
        useReachedTeamSeatsLimit();

    const closeModal = useCallback(() => {
        handleClose();
    }, [handleClose]);

    const handleReachedSeatsLimit = (isReached: boolean) => {
        setWillReachSeatsLimit(isReached);
    };

    return (
        <Modal
            isOpen
            closeAfterTransition
            center
            styles="px-11 my-6 pt-9 pb-8 rounded-lg shadow-md"
        >
            <Fade
                in
                timeout={{
                    enter: 500,
                    exit: 300,
                }}
            >
                <Box>
                    <Box className="flex gap-3">
                        <PersonPlusIcon
                            width={52}
                            height={37}
                            color={ENTITY_COLOR.teams}
                        />
                        <Typography className="self-center text-2xl font-bold">
                            {t('TeamInvitationModal:title')}
                        </Typography>
                    </Box>
                    {willReachSeatsLimit && <ReachedOutMaximumTeamCapacity />}

                    {hasReachedSeatsLimit === false ? (
                        <InvitationUrlSection
                            isDisabled={willReachSeatsLimit}
                        />
                    ) : null}

                    <Divider
                        sx={{
                            backgroundColor: COLOR.borderGrey,
                            borderColor: COLOR.borderGrey,
                            my: '20px',
                            mx: '-44px',
                        }}
                    />

                    <ContactInvitationForm
                        handleClose={closeModal}
                        handleSuccessInvitation={handleSuccessInvitation}
                        hasReachedSeatsLimit={hasReachedSeatsLimit || false}
                        takenSeats={takenSeats}
                        seatsLimit={seatsLimit}
                        handleReachedSeatsLimit={handleReachedSeatsLimit}
                    />
                </Box>
            </Fade>
        </Modal>
    );
}

export default TeamInvitationModal;
